/* eslint-disable import/no-anonymous-default-export */
export default {
  SINGLE_LESSONS: [
    "Single 30min Lesson ($50)",
    "Single 45min Lesson ($65)",
    "Single 60min Lesson ($80)",
  ],
  ONE_SWIMMER_OPTION: [
    "8 lessons (30mins each, $375)",
    "12 lessons (30mins each, $550)",
    "16 lessons (30mins each, $700)",
    "8 lessons (45mins each, $510)",
    "12 lessons (45mins each, $720)",
    "16 lessons (45mins each, $900)",
    "8 lessons (60mins each, $630)",
    "12 lessons (60mins each, $900)",
    "16 lessons (60mins each, $1120)",
  ],
  TWO_SWIMMER_OPTION: [
    "8 lessons (30mins each, $710)",
    "12 lessons (30mins each, $1010)",
    "16 lessons (30mins each, $1280)",
    "8 lessons (45mins each, $950)",
    "12 lessons (45mins each, $1320)",
    "16 lessons (45mins each, $1600)",
    "8 lessons (60mins each, $1200)",
    "12 lessons (60mins each, $1600)",
    "16 lessons (60mins each, $2050)",
  ],
  THREE_SWIMMER_OPTION: [
    "8 lessons (30mins each, $960)",
    "12 lessons (30mins each, $1290)",
    "16 lessons (30mins each, $1650)",
  ],
  FOUR_SWIMMER_OPTION: [
    "8 lessons (30mins each, $1120)",
    "12 lessons (30mins each, $1450)",
    "16 lessons (30mins each, $1875)",
  ],
  FIVE_SWIMMER_OPTION: [
    "8 lessons (30mins each, $1250)",
    "12 lessons (30mins each, $1650)",
    "16 lessons (30mins each, $2000)",
  ],
};
